module.exports = __webpack_public_path__ + "img/balkam.69555a60.svg";